import { IAppState } from '../../redux';
import { IBillingProblemReasons } from '../../types/reducers/billingStatus';

export const selectBillingProblemReasons = (state: IAppState): IBillingProblemReasons => {
  return state.billingStatus.problemReasons;
};
